import { Component, OnInit } from '@angular/core';
import { MenuModuleEnum } from 'src/app/shared/menu/menu.module.enum';

@Component({
  selector: 'app-consulting',
  templateUrl: './consulting.component.html',
  styleUrls: ['./consulting.component.css']
})
export class ConsultingComponent implements OnInit {

  constructor() { }

  public menuModuleEnum:MenuModuleEnum = MenuModuleEnum.consulting;

  ngOnInit(): void {
  }

}
